<template>
  <sa-page-layout :btnSaveVisible="btnSaveVisible" :btnAnnullaVisible="true" :linkback="linkback"
    :pathResource="pathResource" :data="jsonData" :showModalLoading="showModalLoading" class="sa-no-space"
    @beforeSave="onBeforeSave">
    <!-- <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickSalva">
                <b-icon icon="check"> </b-icon>
                Nuovo
            </b-button>
        </template> -->
    <template slot="table-body">
      <magazzino-articoli-edit-component @updateJsonData="onUpdateJsonData" @beforeLoadData="onBeforeLoadData"
        @afterLoadData="onAfterLoadData" ref="cmpMagazzinoArticoliEdit" />
    </template>
  </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import MagazzinoArticoliEditComponent from "../components/MagazzinoArticoliEditComponent.vue";
export default {
  name: "MagazzinoArticoliEditPage",
  components: { SaPageLayout, MagazzinoArticoliEditComponent },
  data() {
    return {
      btnSaveVisible: true,
      showModalLoading: false,
      linkback: "/magazzino/articoli",
      pathResource: "/magazzinoarticoli",
      jsonData: {
        id: null,
        codiceTipoArticolo: null,
        codiceArticolo: null,
        codiceBarre: null,
        nomeArticolo: null,
        descrizioneArticolo: null,
        codiceAzienda: null,
        categoria: null,
        marca: null,
        descrizioneMultiplo: null,
        descrizioneImballo: null,
        codiceIva: null,
        gestioneLottiScadenze: null,
        gestioneMatricole: null,
        ultimoPrezzoAcquisto: null,
        prezzoMedioAcquisto: null,
        scontoArticolo: null,
        sottoscortaArticolo: null,
        prezzoAcquistoStandard: null,
        colliArticolo: null,
        pesoArticolo: null,
        lunghezzaArticolo: null,
        altezzaArticolo: null,
        larghezzaArticolo: null,
        noteArticolo: null,
        giacenze: null,
        codiceAic: null,
        distintaBase: [],
        umBaseId: null,
        umId: null,
      },
    };
  },
  mounted() {
    this.$refs.cmpMagazzinoArticoliEdit.init(this.jsonData)
  },

  methods: {
    onUpdateJsonData(jsonData) {
      this.jsonData = jsonData;
    },
    onBeforeLoadData() {
      let me = this;
      me.showModalLoading = true;
    },
    onAfterLoadData() {
      let me = this;
      me.showModalLoading = false;

    },
    onBeforeSave(jsonData) {
      console.log(jsonData);
      if (jsonData.distintaBase.length > 0) {
        jsonData.distintaBase.forEach(element => {
          delete element.unitaMisuraOptions
          delete element.infogiacenza;
        });
      }
    }
  },
};
</script>

<style></style>
